angular.module('myConsultApp').factory('ActivityService', function ($resource, ENV, Session) {
  var activityService = {};

  activityService.getActivities = function (id, qs) {
    var user = $resource(
      ENV.apiEndpoint + '/1.0/identities/:id/activities/' + qs,
      { id: id },
      { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } },
    );

    return user.get().$promise.then(function (response) {
      return response;
    });
  };

  activityService.getActivitiesList = function (
    search,
    activity,
    requires_moderation,
    order,
    limit,
    pageno,
  ) {
    /*
          -1 = Incomplete
          1 = Submitted
          2 = Approved
          sample request:
            http://localhost:28000/1.0/activities/
          */

    var user = $resource(
      ENV.apiEndpoint + '/1.0/activities/',
      {},
      { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } },
    );

    var searchData = {
      search: search,
      activity_id: activity,
      requires_moderation: requires_moderation,
      order: order,
      page_size: limit,
      page: pageno,
    };

    return user.get(searchData).$promise.then(function (response) {
      return response;
    });
  };

  activityService.getPage = function (url) {
    var activities = $resource(
      url,
      {},
      { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } },
    );

    return activities.get({}).$promise.then(function (response) {
      return response;
    });
  };

  activityService.updateActivity = function (activityId, params) {
    var activity;
    activity = $resource(
      ENV.apiEndpoint + '/1.0/activities/:activityId/',
      { activityId: activityId },
      { save: { method: 'PUT', headers: { Authorization: 'Bearer ' + Session.accessToken } } },
    );

    return activity.save(params).$promise.then(function (response) {
      return response;
    });
  };

  activityService.getActivityTypes = function () {
    var activityTypes = $resource(
      ENV.apiEndpoint + '/1.0/activity-types/',
      {},
      { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } },
    );

    var searchData = {
      status: 'enabled,disabled',
      paginate: false,
      order: 'title',
      manual_trigger_enabled: true,
    };
    return activityTypes.get(searchData).$promise.then(function (response) {
      return response;
    });
  };

  activityService.applyUserActivity = function (data) {
    var activity = $resource(
      ENV.apiEndpoint + '/1.0/user-activity/',
      {},
      {
        save: {
          method: 'POST',
          headers: { Authorization: 'Bearer ' + Session.accessToken },
        },
      },
    );

    return activity.save(data).$promise.then(function (response) {
      return response;
    });
  };

  return activityService;
});
